/**
 * Community Create Post Route
 */
import { createFileRoute } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

export const Route = createFileRoute('/_authenticated/community/create-post')({
  // Template-first pending while the create-post chunk downloads (def files
  // stay eager, so the title is inlined from v2.createPostPage.title). The
  // post form submits from the sticky BottomAction bar.
  pendingComponent: () => <FormPageTemplatePending title="What's Brewing?" cta />,
});
